<div class="default-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-row content">
    <div class="flex flex-col justify-between w-100-percent">
      <div class="flex flex-row w-100-percent">
        <h1 class="flex flex-wrap basis-full mat-headline-5 mb-24 fw-600 mr-98">{{title}}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false">
        </mat-icon>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row">
          <label class="mb-6 mr-10 fs-14 fw-700 mat-headline-6">{{'SOLUTION_SUMMARY.CREATE_SANDBOX.SERVICE_NAME' | transloco
            | uppercase}}</label>
            <mat-icon svgIcon="info" class="cursor-pointer icon-sm" matTooltipClass="right" [matTooltip]="'SOLUTION_SUMMARY.CREATE_SANDBOX.SERVICE_NAME' | transloco | titlecase"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input type="text" class="fw-400 h-48 no-border pale-blue-2-bg field-widths fs-16" [value]="serviceName"
          placeholder="{{ 'SOLUTION_SUMMARY.CREATE_SANDBOX.CUSTOM_SANDBOX' | transloco }}" [attr.disabled]="true">
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row">
          <label class="mb-6 mr-10 fs-14 fw-700 mat-headline-6">{{'SOLUTION_SUMMARY.CREATE_SANDBOX.DESCRIPTION' | transloco |
            uppercase}}</label>
            <mat-icon svgIcon="info" class="cursor-pointer icon-sm" matTooltipClass="right" [matTooltip]="'SOLUTION_SUMMARY.CREATE_SANDBOX.DESCRIPTION' | transloco | titlecase"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <textarea class="p-10 text-area-height field-widths fs-16 fw-400" placeholder="{{'CONTACT_US.TYPE_MESSAGE' | transloco}}"
          formControlName="message" maxlength="300" [value]="punchline" [attr.disabled]="true">
        </textarea>
      </div>
      <h1 class="flex flex-wrap basis-full mat-subtitle-2 mb-14 fw-700 mr-98 mt-0">{{'SOLUTION_SUMMARY.CREATE_SANDBOX.CREATING_SANDBOX' | transloco }} </h1>
      <ul class="mat-body-1 fw-400 mt-0 sandbox-desc">
        <li>{{ "SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX_DESCRIPTION_1" | transloco }}</li>
        <li>{{ "SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX_DESCRIPTION_2" | transloco }}</li>
        <li>{{ "SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX_DESCRIPTION_3" | transloco }}</li>
        <li> {{ "SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX_DESCRIPTION_4" | transloco }}</li>
        <li> {{ "SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX_DESCRIPTION_5" | transloco }}</li>
      </ul>

      <div class="flex flex-row justify-end w-100-percent">
        <button class="white mr-12" [matDialogClose]="false">{{'DIALOG.CANCEL'| transloco}}</button>
        <button class="accent" [matDialogClose]="true">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</div>
